import React from "react";

import './service.css';

import { StyledParagraph, StyledLink } from "../styles/Typography.styled";
import { ProjectsContainer, StyledProjects } from "../styles/Projects.styled";
import { SectionHeading, SectionTitle } from "../styles/SectionHeading";

const Service = () => {
    return (

<div className="container">
<StyledProjects id="services">
      <SectionHeading>
        <SectionTitle number="03">Services</SectionTitle>
      </SectionHeading>
</StyledProjects>
  <div className="row">
    <div className="service">
      <i className="fas fa-laptop-code" />
      <h2>Web Design</h2>
      <p>
      Specializing in web design services, I craft visually stunning and user-friendly websites that captivate audiences and elevate digital presence
      </p>
    </div>
    <div className="service">
      <i className="fas fa-chart-line" />
      <h2>Web Development</h2>
      <p>
      Offering comprehensive web design and development services, I transform concepts into dynamic websites, combining creativity with technical expertise for optimal user experiences.
      </p>
    </div>
    <div className="service">
      <i className="fab fa-sketch" />
      <h2>Machine Learning</h2>
      <p>
      Implementing cutting-edge machine learning techniques, I develop intelligent solutions that analyze data, predict patterns, and drive informed decision-making for diverse applications.
      </p>
    </div>
    <div className="service">
      <i className="fas fa-database" />
      <h2>Data Analysis</h2>
      <p>
      Delivering insightful data analysis services, I uncover valuable insights, trends, and patterns within datasets to drive informed decision-making and business growth.
      </p>
    </div>
    <div className="service">
      <i className="fas fa-mobile-alt" />
      <h2>App Development</h2>
      <p>
      Crafting innovative app solutions, I design and develop intuitive mobile applications that seamlessly integrate functionality, user experience, and cutting-edge technology.
      </p>
    </div>
    <div className="service">
      <i className="fas fa-file-invoice" />
      <h2>Expert Canva Designer</h2>
      <p>
      Proficient Canva designer offering creative services to produce eye-catching graphics, presentations, and marketing materials tailored to your brand's needs.
      </p>
    </div>
    <div className="service">
      <i className="fas fa-money-check-alt" />
      <h2>Image & Video Editor</h2>
      <p>
      Enhancing Visual Content with Precision and Creativity.
      </p>
    </div>
    <div className="service">
      <i className="fas fa-network-wired" />
      <h2>Cyber Security</h2>
      <p>
      Providing comprehensive cyber security solutions, I safeguard digital assets and networks against evolving threats, ensuring peace of mind and uninterrupted operations.
      </p>
    </div>
  </div>
</div>


  );
};

export default Service;
